// extracted by mini-css-extract-plugin
export default {"button-container":"sqior-file-upload_button-container__JvOKT","preview-image-container":"sqior-file-upload_preview-image-container__wfYVD"};